import { render, staticRenderFns } from "./IpadAlert.vue?vue&type=template&id=0f8be376&scoped=true&"
import script from "./IpadAlert.vue?vue&type=script&lang=js&"
export * from "./IpadAlert.vue?vue&type=script&lang=js&"
import style0 from "./IpadAlert.vue?vue&type=style&index=0&id=0f8be376&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8be376",
  null
  
)

export default component.exports